// src/data/fullReports.js
const fullReports = [
  { id: 1, title: "Financial Report", link: "/full-reports/financial" },
  { id: 2, title: "Career Report", link: "/full-reports/career" },
  { id: 3, title: "Medical Report", link: "/full-reports/medical" },
  { id: 4, title: "Sade Sati Report", link: "/full-reports/sade-sati" },
  { id: 5, title: "Yearly Report", link: "/full-reports/yearly" },
  { id: 6, title: "Ashtakvarga Report", link: "/full-reports/ashtakvarga" },
  { id: 7, title: "Varga Kundali Report", link: "/full-reports/varga-kundali" },
  { id: 8, title: "Full Report", link: "/full-reports/complete" }
]

export default fullReports